import axios from 'axios';
import { CreateLockedPondsInput } from 'views/production-systems/types/locked-ponds/create-locked-ponds-input.type';

// POST
// ​/ewosapi​/v1​/shrimps​/lock-ponds​/{siteId}​/extend
export const postExtendLockedPonds = async (siteId: string, releasePondsRequest: CreateLockedPondsInput) => {
  const res = await axios.post(`/ewosapi/v1/shrimps/lock-ponds/${siteId}/extend`, releasePondsRequest);
  return res.data;
};
